import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly storageKey = 'controlps_lang';
  private readonly supported = ['pt', 'en'] as const;
  private currentLang$ = new BehaviorSubject<string>('pt');

  constructor(private translate: TranslateService) {
    this.translate.addLangs([...this.supported]);
    this.translate.setDefaultLang('pt');
  }

  init() {
    const saved = this.getSavedLang();
    const initial = saved && this.supported.includes(saved as any) ? saved : 'pt';
    this.use(initial);
  }

  use(lang: string) {
    const next = this.supported.includes(lang as any) ? lang : 'pt';
    this.translate.use(next);
    this.currentLang$.next(next);
    try {
      localStorage.setItem(this.storageKey, next);
    } catch (_) {}
    if (typeof document !== 'undefined') {
      document.documentElement.lang = next;
    }
  }

  toggle() {
    const next = this.currentLang$.value === 'pt' ? 'en' : 'pt';
    this.use(next);
  }

  current() {
    return this.currentLang$.value;
  }

  changes() {
    return this.currentLang$.asObservable();
  }

  private getSavedLang() {
    try {
      return localStorage.getItem(this.storageKey);
    } catch (_) {
      return null;
    }
  }
}
